/**
 * @module container/Book
 * @author Charles Blais <charles.blais@canada.ca>
 */

import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Row, Col } from 'react-bootstrap';

import NetworksTable from '../components/Table/NetworksTable';
import NetworksMap from '../components/Maps/NetworksMap';
import BookSidebar from '../components/BookSidebar'

import { Networks } from '../libs/networks';
import { useLanguageState } from '../contexts/LanguageProvider';


const BookContainer = ({networks}) => {
  const [ lang ] = useLanguageState();
  return (
    <Grid>
      <Row>
        <Col md={8}>
          <NetworksMap
            networks={networks}
          />
          <details>
            <summary>{lang.instructionsLabel}</summary>
            <p>{lang.instructions}</p>
          </details>
        </Col>
        <Col md={4}>
          <BookSidebar />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <h2>{ lang.completeList }</h2>
          <NetworksTable
            networks={networks}
          />
        </Col>
      </Row>
    </Grid>
  )
};


BookContainer.propTypes = {
  networks: PropTypes.instanceOf(Networks),
};


BookContainer.defaultProps = {
  networks: new Networks(),
};


export default BookContainer;
